"use strict";import{html as r}from"@cisco-u/base";export function uFill({height:e="100%",width:l=259,hidden:t=!1,title:i=""}={}){return r`<svg
    width=${l}
    height=${e}
    viewBox="0 0 259 260"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${t?"true":"false"}"
    aria-label="${i}"
  >
    <path
      d="M0 0H201V153.5C201 209.005 156.005 254 100.5 254C44.9954 254 0 209.005 0 153.5V0Z"
      fill="white"
    />
    <circle cx="224" cy="228" r="23" fill="white" />
  </svg>`}
//# sourceMappingURL=u-fill.js.map
